// import PhoneField from 'elements/field/PhoneField'
import { countryMapping } from 'constants/countries'
import PhoneField from 'elements/field/PhoneField'
import React, { useEffect } from 'react'
import { useField } from 'react-final-form'

interface PhoneInputProps {
  source: string
  label: string
  fullWidth?: boolean
  initialCountry?: string
  initialPhone?: string
  validate: any[]
  onFocus?: (event: React.FocusEvent<HTMLInputElement>) => void
}

export const PhoneInput = ({
  initialCountry,
  initialPhone,
  source,
  label,
  fullWidth,
  validate,
  onFocus,
}: PhoneInputProps) => {
  const source_metadata = source + '_metadata'

  const {
    input: { onChange: changeSourcePhoneWithCode },
  } = useField(source, {
    subscription: { value: true },
  })

  const {
    input: { value: prefixIso2, onChange: changePrefix },
  } = useField(`${source_metadata}.custom_data.os_meta.phone_country_iso2`, {
    subscription: { value: true },
  })

  const {
    input: { value: phoneWithoutPrefix, onChange: changePhoneOnly },
  } = useField(`${source_metadata}.phone`, {
    subscription: { value: true },
  })

  const {
    input: { value: orgCountryIso2 },
  } = useField(`org_registration.country_iso2`, {
    subscription: { value: true },
  })

  useEffect(() => {
    if (!phoneWithoutPrefix) {
      const country = initialCountry || orgCountryIso2
      changePrefix(country)
    }
    if (!phoneWithoutPrefix && initialPhone) {
      changePhoneOnly(initialPhone)
    }
  }, [initialCountry, initialPhone, orgCountryIso2])

  useEffect(() => {
    // Sanitize the phone number input so that any leading '+' or other non-digit
    // characters are removed before we concatenate it with the country prefix.
    // This prevents issues such as sending numbers like '+1+2642355678' to the
    // backend when the user accidentally types the leading '+'.
    const sanitizedPhoneNumber = phoneWithoutPrefix?.replace(/[^0-9]/g, '') || ''

    const sanitizedCountryPrefix = countryMapping?.[prefixIso2]?.prefix?.replace(/[^0-9]/g, '') || ''

    const countryCode =
      sanitizedCountryPrefix && sanitizedPhoneNumber ? `+${sanitizedCountryPrefix}${sanitizedPhoneNumber}` : ''
    changeSourcePhoneWithCode(countryCode)
  }, [prefixIso2, phoneWithoutPrefix])

  return (
    <PhoneField
      source={source_metadata}
      isFullWidth={fullWidth}
      label={label}
      validate={validate}
      renderPhoneCodeValue
      onFocus={onFocus}
    />
  )
}
